import { Column, Content} from "@carbon/react";
import { Fragment } from "react";
import { OnboardingHeader } from "./OnboardingHeader";

import { OnboardingOne} from "./OnboardingOne";
import { OnboardingTwo } from "./OnboardingTwo";
import { OnboardingThree} from "./OnboardingThree";
import { OnboardingFour} from "./OnboardingFour";
import { OnboardingFive } from "./OnboardingFive";
import { OnboardingSix } from "./OnboardingSix";


export const View = (props) => {
  const {
    step,
    stepsPerPage,
    handleNext,
    handleComplete,
    handleCancel,
  } = props;

  const onboardingStepPages = [
    <OnboardingOne
      handleNext={handleNext}
      isActive={step === 1}
    />,
    <OnboardingTwo
      handleNext={handleNext}
      isActive={step === 2}
    />,
    <OnboardingThree
      handleNext={handleNext}
      isActive={step === 3}
    />,
    <OnboardingFour
      handleNext={handleNext}
      isActive={step === 4}
    />,
    <OnboardingFive
      handleNext={handleNext}
      isActive={step === 5}
    />,
    <OnboardingSix
      handleNext={handleNext}
      isActive={step === 6}
    />,
  ];

  return (
    <Content className="onboarding-content">
      <Column lg={16} md={8} sm={4}>
        <OnboardingHeader
          handleComplete={handleComplete}
          handleCancel={handleCancel}
        />

       

        <div className="flex-container flex-break--small onboarding-container">
          {onboardingStepPages.map((page, index) => {
            const pageStepNumber = index + 1;
            const isActive = pageStepNumber === step;
            const isDisabled = pageStepNumber > step;
            // const isCompleted = pageStepNumber < step;
            const isFirstPageInView = pageStepNumber % stepsPerPage === 1;

            const isVisible =
              Math.floor(index / stepsPerPage) ===
              Math.max(Math.floor((step - 1) / stepsPerPage), 0);

            return isDisabled || !isVisible ? null : (
              <Fragment key={index}>
                {isFirstPageInView ? null : <div className="flex-divider" />}

                {
                  <div
                    className={`flex-box flex-container section-container ${
                      !isActive ? "page-inactive" : ""
                    }`}
                  >
                    {page}
                  </div>
                }
              </Fragment>
            );
          })}

          {Array.from(
            { length: (stepsPerPage - (step % stepsPerPage)) % stepsPerPage },
            (v, k) => k
          ).map((v, k) => (
            <div key={k} className="flex-box inactive-steps--cover" />
          ))}
        </div>
      </Column>
    </Content>
  );
};
